import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function incidentCategoryDataReducer(state = initialState.incidentCategoryData, action) {
  switch (action.type) {
    case types.LOAD_INCIDENT_CATEGORY_DATA_SUCCESS:
      return action.incidentCategoryData;
    default:
      return state;
  }
}
